<template>
    <div>
        <van-nav-bar
                title="分类"
                left-arrow
                :fixed="true"
                class="my-nav"
                @click-left="onClickLeft"
                @click-right="onClickRight"
        >
            <van-icon name="search" slot="right"/>
        </van-nav-bar>
        <div>
            <van-row style="font-size: 14px;">
                <van-col span="8"
                         style="border-right: 1px solid #efefef;  padding-top: 46px;  position: absolute; height: 100%;overflow-y: scroll;">
                    <van-cell
                            v-for="item in list"
                            :key="item.id"
                            :title="item.name"
                            :class="{ 'active-category': categoryId == item.id }"
                            @click="onClickCategory(item)"
                    />
                </van-col>
                <van-col span="16"
                         style=" position: absolute; padding-top: 46px; margin-left: 30%; width: 70%; overflow-y: scroll;height: 90vh">
                    <div style="width: 100%;display: flex;flex-wrap: wrap; padding: 1vh 2vw">
                        <div v-for="item in brands" :key="item.id" @click="onSearch(item.id)" style="display: flex;flex-direction: column; width: 50%;align-items: center;margin-bottom: 5vh">
                            <img :src="item.img" style="width: 48px;height: auto;margin-bottom: 0.5vh">
                            <span style="font-size: 12px">{{item.name}}</span>
                        </div>
                    </div>
                </van-col>
            </van-row>
        </div>
    </div>
</template>

<script>
  import {listCategory, listBrands} from '../../api/classification'

  export default {
    data() {
      return {
        categoryId: '',
        list: [],
        brands: []
      };
    },
    mounted() {
      listCategory(d => {
        this.list = d;
        if (d) {
          let categoryId = this.$route.query.categoryId;
          let matched = categoryId && d.find(function(item) { return item.id == categoryId; });
          this.selectCategory(matched || d[0], false);
          console.log(categoryId,matched)

        }
      })
    },
    methods: {
      selectCategory(item, updateRoute) {
        this.categoryId = item.id;
        if (updateRoute) {
          this.$router.replace({ query: { categoryId: item.id } });
        }
        listBrands(item.id, brands => {
          this.brands = brands;
        })
      },
      onClickCategory(item) {
        this.selectCategory(item, true);
      },
      onSearch(categoryId) {
        this.$router.push({path:'search', query: {categoryId}});
      },
      onClickLeft() {
        this.$router.back(-1)
      },
      onClickRight() {
        this.$router.push('search');
      }
    }
  }
</script>

<style lang="less" scoped>
    .active-category {
        background: #fff;
        color: var(--primary);
        border-left: 3px solid var(--primary);
    }

    .demo_line {
        padding: 0 20px 0;
        margin: 20px 0;
        line-height: 1px;
        border-left: 60px solid #ddd;
        border-right: 60px solid #ddd;
        text-align: center;
    }

    .span {
        ul {
            list-style: none;
            li {
                height: 36px;
                line-height: 36px;
                box-sizing: border-box;
                display: inline-block;
                margin: 8px;
                padding: 0 15px;
                background: #eee;
                border-radius: 18px;
            }
        }
    }
</style>